<template>
    
  <!-- Portfolio Grid -->
  <section class="bg-light" id="portfolio">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Portfolio</h2>
          <h3 class="section-subheading text-muted">Cartera de trabajos realizados.</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-6 portfolio-item">
          <a class="portfolio-link">
            <img class="img-fluid" src="./../../assets/img/portfolio/01-thumbnail.jpg" alt="">
          </a>
          <div class="portfolio-caption">
            <h4>Presupuestador</h4>
            <p class="text-muted">Generación de presupuestos para taller</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 portfolio-item">
          <a class="portfolio-link">
            <img class="img-fluid" src="./../../assets/img/portfolio/02-thumbnail.jpg" alt="">
          </a>
          <div class="portfolio-caption">
            <h4>Super SiTi</h4>
            <p class="text-muted">Gestión de supermercados</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 portfolio-item">
          <a class="portfolio-link">
            <img class="img-fluid" src="./../../assets/img/portfolio/03-thumbnail.jpg" alt="">
          </a>
          <div class="portfolio-caption">
            <h4>Web Sites</h4>
            <p class="text-muted">Sitios personalizados</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 portfolio-item">
          <a class="portfolio-link">
            <img class="img-fluid" src="./../../assets/img/portfolio/04-thumbnail.jpg" alt="">
          </a>
          <div class="portfolio-caption">
            <h4>Consultoría</h4>
            <p class="text-muted">Asesoramiento en procesos</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 portfolio-item">
          <a class="portfolio-link">
            <img class="img-fluid" src="./../../assets/img/portfolio/05-thumbnail.jpg" alt="">
          </a>
          <div class="portfolio-caption">
            <h4>Desarrollos</h4>
            <p class="text-muted">Desarrollos a medida</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 portfolio-item">
          <a class="portfolio-link">
            <img class="img-fluid" src="./../../assets/img/portfolio/06-thumbnail.jpg" alt="">
          </a>
          <div class="portfolio-caption">
            <h4>Staff Tecnológico</h4>
            <p class="text-muted">Utilización de multiples tecnologías</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name:'portfolio-component'
}
</script>



// WEBPACK FOOTER //
// src/components/PortfolioComponent/portfolioComponent.vue